export function removeNullField(duration: number): number | undefined {
  if (Number.isNaN(duration) || !Number.isFinite(duration)) {
    return undefined
  }

  return duration
}
